module.exports = __webpack_public_path__ + "static/media/student-snapshort1-level.79096b3e.png";